import { Component, Input, OnInit } from '@angular/core';
import { TimeFilter } from 'src/app/models/enums';
import { IEvenResultsAndScoreGroups } from 'src/app/models/results/evenResultsAndScoreGroups.interface';
import { IEventResult } from 'src/app/models/results/eventResult.interface';
import { EventsService } from 'src/app/services/events.service';
import { LoaderService } from 'src/app/services/loader.service';
import { SportsService } from 'src/app/services/sports.service';

@Component({
  selector: 'app-results-sport-selection-container-mobile',
  templateUrl: './results-sport-selection-container-mobile.component.html',
  styleUrls: ['./results-sport-selection-container-mobile.component.less']
})
export class ResultsSportSelectionContainerMobileComponent implements OnInit {

  public evenResultsAndScoreGroups: IEvenResultsAndScoreGroups = {
    eventResults: [],
    scoreGroups: [],
  };

  public filteredEventResults: IEventResult[] = [];


  @Input()
  timeFilterValue: TimeFilter;

  constructor(
    private sportsService: SportsService,
    private eventsService: EventsService,
    private loaderService: LoaderService) {

  }


  ngOnInit(): void {
    this.getEventResultsAndScoreGroups();
  }

  private getEventResultsAndScoreGroups() {

    this.loaderService.showHideLoader(true);
    this.eventsService.getFinishedEventsResultsForSelection(
      this.timeFilterValue,
      this.sportsService.sportRegionCompetitionSelection.sport,
      this.sportsService.sportRegionCompetitionSelection.region,
      // always get for whole region because cmp cant be selected before region is loaded
      null).subscribe((res) => {
        this.evenResultsAndScoreGroups = res;
        this.filterBySelection();
        this.loaderService.showHideLoader(false);
      });

  }

  filterBySelection() {

    this.filteredEventResults = this.evenResultsAndScoreGroups.eventResults.filter(res => res.competitionId === this.sportsService.sportRegionCompetitionSelection.competition.id);

  }
}

